import { Grid, Tooltip} from "@mui/material";

export function getMlmcreditStruct(){
    return {
        id:{
            name:'id',
            label:'ID',
            value:'',
            error:false,
            errorMessage:'',
            required:false
        },
        
        businessid:{
            name:'businessid',
            label:'Business Id',
            value:'',
            error:false,
            errorMessage:'You must enter Business Id',
            required:true,
            fieldtype:'ID'
        },
        title:{
            name:'title',
            label:'Title',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        orderid:{
            name:'orderid',
            label:'Order Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        creditlevel:{
            name:'creditlevel',
            label:'Credit Level',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        creditvalue:{
            name:'creditvalue',
            label:'Credit Value',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        srpartnerid:{
            name:'srpartnerid',
            label:'Sr Partner Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        srpartnername:{
            name:'srpartnername',
            label:'Sr Partner Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        ordervalue:{
            name:'ordervalue',
            label:'Order Value',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        mlmuserid:{
            name:'mlmuserid',
            label:'MLM User Id',
            value:'',
            error:false,
            errorMessage:'You must enter MLM User Id',
            required:true,
            fieldtype:'bodynamiclist'
        },
        mlmusername:{
            name:'mlmusername',
            label:'MLM User Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        creditviaid:{
            name:'creditviaid',
            label:'Credit Via Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        creditvianame:{
            name:'creditvianame',
            label:'Credit Via Name',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'string'
        },
        creditpercentage:{
            name:'creditpercentage',
            label:'Credit Percentage',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'double'
        },
        paymentid:{
            name:'paymentid',
            label:'Payment Id',
            value:'',
            error:false,
            errorMessage:'You must enter Payment Id',
            required:true,
            fieldtype:'string'
        },
        credittype:{
            name:'credittype',
            label:'Credit Type',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'number'
        },
        creditdate:{
            name:'creditdate',
            label:'Credit Date',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'date'
        },
        creditstatusid:{
            name:'creditstatusid',
            label:'Credit Status Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        userid:{
            name:'userid',
            label:'User Id',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
        transferreqid:{
            name:'transferreqid',
            label:'TransferReqId',
            value:'',
            error:false,
            errorMessage:'',
            required:false,
            fieldtype:'ID'
        },
      }
}

export function getColumns(payload){
  let actionList = [
        
        { field: 'title', headerName: 'Title', width:100 },
        { field: 'orderid', headerName: 'Order Id', width:150 },
        { field: 'creditlevel', headerName: 'Credit Level', width:150 },
        { field: 'creditvalue', headerName: 'Credit Value', width:150 },
        { field: 'srpartnerid', headerName: 'Sr Partner Id', width:150 },
        { field: 'srpartnername', headerName: 'Sr Partner Name', width:150 },
        { field: 'creditpercentage', headerName: 'Credit Percentage', width:150 },
        { field: 'paymentid', headerName: 'Payment Id', width:150 },
        { field: 'credittype', headerName: 'Credit Type', width:150 },
        { field: 'creditdate', headerName: 'Credit Date', width:150 },
        { field: 'creditstatusid', headerName: 'Credit Status Id', width:150 },
        { field: 'userid', headerName: 'User Id', width:150 },
        { field: 'transferreqid', headerName: 'TransferReqId', width:150 },
  ];
  if (payload!==undefined){
    payload.actionList && payload.actionList.map((actionObj)=>{
    actionList.push(
      {
        field: actionObj.title,
        headerName: actionObj.title,
        sortable: false,
        width:60,
        disableClickEventBubbling: false,
        renderCell: (params) => {
          return (
              <Grid item onClick={()=>{actionObj.callBackMethod(params.row.id)}}>
                <Tooltip title={actionObj.title} sx={{cursor: "pointer"}}>
                  {actionObj.icon}
                </Tooltip>
              </Grid>
          );
        }
      })
    })
  }
  return actionList;
}

export function setData(data, formValues, setFormValues){
   
    setFormValues({
      ['id']:{
        ...formValues['id'],
        value:data.id,
      },
       ['businessid']:{
          ...formValues['businessid'],
          value:data.businessid,
        },['title']:{
          ...formValues['title'],
          value:data.title,
        },['orderid']:{
          ...formValues['orderid'],
          value:data.orderid,
        },['creditlevel']:{
          ...formValues['creditlevel'],
          value:data.creditlevel,
        },['creditvalue']:{
          ...formValues['creditvalue'],
          value:data.creditvalue,
        },['srpartnerid']:{
          ...formValues['srpartnerid'],
          value:data.srpartnerid,
        },['srpartnername']:{
          ...formValues['srpartnername'],
          value:data.srpartnername,
        },['ordervalue']:{
          ...formValues['ordervalue'],
          value:data.ordervalue,
        },['mlmuserid']:{
          ...formValues['mlmuserid'],
          value:data.mlmuserid,
        },['mlmusername']:{
          ...formValues['mlmusername'],
          value:data.mlmusername,
        },['creditviaid']:{
          ...formValues['creditviaid'],
          value:data.creditviaid,
        },['creditvianame']:{
          ...formValues['creditvianame'],
          value:data.creditvianame,
        },['creditpercentage']:{
          ...formValues['creditpercentage'],
          value:data.creditpercentage,
        },['paymentid']:{
          ...formValues['paymentid'],
          value:data.paymentid,
        },['credittype']:{
          ...formValues['credittype'],
          value:data.credittype,
        },['creditdate']:{
          ...formValues['creditdate'],
          value:data.creditdate,
        },['creditstatusid']:{
          ...formValues['creditstatusid'],
          value:data.creditstatusid,
        },['userid']:{
          ...formValues['userid'],
          value:data.userid,
        },['transferreqid']:{
          ...formValues['transferreqid'],
          value:data.transferreqid,
        },
      })
}